<template>
    <div id="dialog-modal">
        <div class="modal-main-content">
            <p :style="{color: textColorData}" v-html="text"></p>
        </div>
        <div v-if="date">
            <p>{{$t('message.setStartDateFor')}}{{param.first_name}}
                {{param.last_name}}{{$t('message.taskOnTheProject')}}:</p>
            <div style="width: 30%; margin: 2% auto;">
                <input v-model="dateData" @click="showMonthPicker = !showMonthPicker"
                       type="text"
                       class="form-control"
                       >
            </div>
            <month-picker @change="setStartDate" v-if="showMonthPicker"
                          style="position: relative; margin: 2% auto; border: none"></month-picker>

            <p></p>
            <div style="width: 30%; margin: 2% auto;">
               
            </div>
            <div style="white-space: nowrap;"> 
                <p style="display: inline-block;"> </p>
                <div style="display: inline-block; width: 30%; margin: 2% auto;">
                    
                </div>
             </div>

                {{$t('message.setContractNumber')}}:
                <input v-model="contractNumberData"
                        type="text"
                        class="form-control"
                        style="display: inline-block; width: 70%; margin: 2% auto;"
                        >
               <!-- <tr><td>{{$t('message.setStaticBudget')}}:</td><td>
                   <input v-model="staticBudgetData"
                            type="number"
                            class="form-control"
                            >
                  </td></tr> -->
            
        </div>
        <div>
            <button @click="confirm" class="btn btn-success modal-buttons">{{$t('message.yes')}}</button>
            <button @click="$emit('close')" class="btn btn-danger modal-buttons">{{$t('message.no')}}</button>
        </div>

    </div>
</template>

<script>
  import { MonthPicker } from 'vue-month-picker'

  export default {
    data () {
      return {
        textColorData: 'grey',
        dateData: null,
        contractNumberData: null,
        staticBudgetData: 0,
        showMonthPicker: false
      }
    },
    components: {
      MonthPicker
    },
    name: 'modal-dialog',
    props: ['text', 'param', 'modalRef', 'textColor', 'event', 'date'],
    created () {
      if (this.textColor) {
        this.textColorData = this.textColor
      }
    },
    methods: {
      hide () {
        this.$modal.hide('my-modal')
      },
      confirm () {
        if (this.date) {
          const param = {}
          param['user'] = this.param
          param['date'] = this.$moment(this.dateData).startOf('month').format('YYYY-MM-DD')
          param['contract_number'] = this.contractNumberData
          param['static_budget'] = this.staticBudgetData
          this.$emit(this.event, param)
          this.$emit('close')
        } else {
          this.$emit(this.event, this.param)
          this.$emit('close')
        }

        if (this.modalRef) {
          this.modalRef.$emit('close')
        }
      },
      setStartDate(date){
        this.dateData = this.$moment(date.from).format('YYYY-MM');
      }
    }
  }
</script>

<style>
    #dialog-modal {
        font-family: "Bitstream Charter";
        text-align: center;
    }

    .modal-main-content {
        color: gray;
        padding: 15px;
        text-align: center;
    }

    .modal-buttons {
        display: inline-block;
        width: 48.5%;
        margin: 0.5%;
    }
</style>
